import { get } from '../utils/api';

export const login = (payload) => get(`token/login?email=${payload.email}&password=${payload.password}`);

export const verifyToken = () => get(`token/`);
